// Helper function, needed for testing in order for us to mock what window.location.origin returns
export const getLocationOrigin = () => {
  return window.location.origin;
};
